// Adding value property in the options as Property id in Option type is no longer supported.
export const SHIPMENT_STATUS_FILTER = [
    {
        "label": "Accepted",
        "id": "Accepted",
        "value": "Accepted"
    },
    {
        "label": "Failed",
        "id": "Failed",
        "value": "Failed"
    },
    {
        "label": "Cancelled",
        "id": "Cancelled",
        "value": "Cancelled"
    }
];

export const PKG_STATE_FILTER = [
    {
        "id": "Scheduled",
        "label": "Scheduled",
        "value": "Scheduled"
    },
    {
        "id": "In-transit",
        "label": "In-transit",
        "value": "In-transit"
    },
    {
        "id": "Cancelled",
        "label": "Cancelled",
        "value": "Cancelled"
    },
    {
        "id": "Delivered",
        "label": "Delivered",
        "value": "Delivered"
    },
    {
        "id": "Returned",
        "label": "Returned",
        "value": "Returned"
    },
    {
        "id": "On-hold",
        "label": "On-hold",
        "value": "On-hold"
    }
];

export const BOOKING_STATUS_FILTER = [
    {
        "label": "Submitted",
        "id": "Submitted",
        "value": "Submitted"
    },
    {
        "label": "Tentative",
        "id": "Tentative",
        "value": "Tentative"
    },
    {
        "label": "Compliance Hold",
        "id": "ComplianceHold",
        "value": "ComplianceHold"
    },
    {
        "label": "Processing",
        "id": "Processing",
        "value": "Processing"
    },
    {
        "label": "On hold",
        "id": "OnHold",
        "value": "OnHold"
    },
    {
        "label": "Pending Assignment",
        "id": "PendingAssignment",
        "value": "PendingAssignment"
    },
    {
        "label": "Redirected",
        "id": "Redirected",
        "value": "Redirected"
    },
    {
        "label": "Shipment planned",
        "id": "ShipmentPlanned",
        "value": "ShipmentPlanned"
    },
    {
        "label": "Booking requested",
        "id": "BookingRequested",
        "value": "BookingRequested"
    },
    {
        "label": "Load tendered",
        "id": "LoadTendered",
        "value": "LoadTendered"
    },
    {
        "label": "Load tender cancelled",
        "id": "LoadTenderCancelled",
        "value": "LoadTenderCancelled"
    },
    {
        "label": "Booking accepted",
        "id": "BookingAccepted",
        "value": "BookingAccepted"
    },
    {
        "label": "Booking rejected",
        "id": "BookingRejected",
        "value": "BookingRejected"
    },
    {
        "label": "Error",
        "id": "Error",
        "value": "Error"
    },
    {
        "label": "Failed",
        "id": "Failed",
        "value": "Failed"
    },
    {
        "label": "Cancelled",
        "id": "Cancelled",
        "value": "Cancelled"
    },
    {
        "label": "InProgress",
        "id": "InProgress",
        "value": "InProgress"
    },
    {
        "label": "Completed",
        "id": "Completed",
        "value": "Completed"
    },
    {
        "label": "Manually Completed",
        "id": "ManuallyCompleted",
        "value": "ManuallyCompleted"
    }
];

export const BOOKING_SOURCE_FILTER = [
    {
        "label": "Booking portal",
        "id": "Booking portal",
        "value": "Booking portal"
    }
];

export const SHOW_CHILD_BOOKING_FILTER = [
    {
        "label": "Yes",
        "id": "Yes",
        "value": "Yes"
    }
];

export const REGION_FILTER = [
    {
        "id": "APAC",
        "label": "APAC",
        "value": "APAC"
    },
    {
        "id": "EMEA",
        "label": "EMEA",
        "value": "EMEA"
    },
    {
        "id": "NALA",
        "label": "NALA",
        "value": "NALA"
    }
];

export const INTERNAL_RACK_TYPES = [
    {
        "id": "Series 6/7/8",
        "label": "Series 6/7/8",
        "value": "Series 6/7/8"
    },
    {
        "id": "S3",
        "label": "S3",
        "value": "S3"
    },
    {
        "id": "GRAVITON 2",
        "label": "GRAVITON 2",
        "value": "GRAVITON 2"
    },
    {
        "id": "GRAVITON 4",
        "label": "GRAVITON 4",
        "value": "GRAVITON 4"
    },
    {
        "id": "INTEL 6-SERIES",
        "label": "INTEL 6-SERIES",
        "value": "INTEL 6-SERIES"
    },
    {
        "id": "INTEL 7-SERIES",
        "label": "INTEL 7-SERIES",
        "value": "INTEL 7-SERIES"
    }
]

export const POSITION_READY_STATUS = [
    {
        "id": "GREEN",
        "label": "GREEN",
        "value": "GREEN"
    },
    {
        "id": "YELLOW",
        "label": "YELLOW",
        "value": "YELLOW"
    },
    {
        "id": "RED",
        "label": "RED",
        "value": "RED"
    },
    {
        "id": "UNKNOWN",
        "label": "NO STATUS",
        "value": "UNKNOWN"
    }
]

export const IS_SHIPMENT_STATUS_RECEIVED_FILTER = [
    {
        "label": "Yes",
        "id": "Yes",
        "value": "true"
    }
]

export const AT_DEST_HUB_FILTER = [
    {
        "label": "Yes",
        "id": "Yes",
        "value": "true"
    },
    {
        "label": "No",
        "id": "No",
        "value": "false"
    }
]

export const SHIPMENT_STATUS = [
    {
        "id": "NRTS",
        "label": "Not Ready to Ship",
        "value": "not ready to ship"
    },
    {
        "id": "RTS",
        "label": "Ready to Ship",
        "value": "ready to ship"
    },
    {
        "id": "OnHold",
        "label": "On Hold",
        "value": "on hold"
    },
    {
        "id": "Shipped",
        "label": "Shipped",
        "value": "shipped"
    },
    {
        "id": "Delivered",
        "label": "Delivered at DC",
        "value": "delivered at dc"
    }
]

export const DESTINATION_HUB_ETA_SOURCE = [
    {
        "id": "CARRIER",
        "label": "Carrier",
        "value": "CARRIER"
    },
    {
        "id": "EDI852",
        "label": "Warehouse feed",
        "value": "EDI852"
    },
    {
        "id": "SYSTEM_CALCULATED",
        "label": "System calculated",
        "value": "SYSTEM_CALCULATED"
    }
]